var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "ed-permissions-background-info",
            title: "Permisos en proceso",
            centered: "",
            "ok-only": "",
            "ok-title": "Entendido",
            "ok-variant": "primary",
            "no-close-on-backdrop": ""
          },
          on: { hidden: _vm.closeBackgroundModal },
          model: {
            value: _vm.showBackgroundModal,
            callback: function($$v) {
              _vm.showBackgroundModal = $$v
            },
            expression: "showBackgroundModal"
          }
        },
        [
          _c(
            "div",
            { staticClass: "text-center p-3" },
            [
              _c("feather-icon", {
                staticClass: "text-primary mb-2",
                attrs: { icon: "ClockIcon", size: "48" }
              }),
              _c("p", { staticClass: "mt-2" }, [
                _vm._v(" Los permisos se están asignando en segundo plano. "),
                _c("br"),
                _c("br"),
                _c("strong", [
                  _vm._v(
                    "Te notificaremos por correo electrónico cuando el proceso termine."
                  )
                ])
              ])
            ],
            1
          )
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "ed-permissions-form-container",
            title: "Permisos",
            "hide-footer": "",
            centered: ""
          },
          model: {
            value: _vm.showModal,
            callback: function($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal"
          }
        },
        [
          _c(
            "form",
            { attrs: { "data-vv-scope": "ed-permissions-form" } },
            [
              _c(
                "div",
                { staticClass: "w-100 pl-5 pr-5 mb-32" },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Selecciona el tipo de permiso",
                        "label-for": "referenceType"
                      }
                    },
                    [
                      _c(
                        "vs-select",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: {
                            autocomplete: "",
                            label: "",
                            id: "referenceType",
                            name: "referenceType",
                            danger: _vm.errors.has(
                              "ed-permissions-form.referenceType"
                            ),
                            "danger-text": _vm.errors.first(
                              "ed-permissions-form.referenceType"
                            ),
                            disabled: _vm.permission !== null
                          },
                          model: {
                            value: _vm.referenceType,
                            callback: function($$v) {
                              _vm.referenceType = $$v
                            },
                            expression: "referenceType"
                          }
                        },
                        [
                          _c("vs-select-item", {
                            attrs: {
                              value: _vm.referenceTypes.USER,
                              text: "Usuario"
                            }
                          }),
                          _c("vs-select-item", {
                            attrs: {
                              value: _vm.referenceTypes.GROUP,
                              text: "Grupo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.referenceType === _vm.referenceTypes.USER
                    ? _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "(*) Usuario",
                            "label-for": "selectedUserId"
                          }
                        },
                        [
                          _vm.permission === null
                            ? _c("ListUser", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required:
                                        _vm.referenceType ===
                                        _vm.referenceTypes.USER
                                    },
                                    expression:
                                      "{ required: referenceType === referenceTypes.USER }"
                                  }
                                ],
                                attrs: {
                                  autocomplete: "",
                                  id: "selectedUserId",
                                  name: "selectedUserId",
                                  label: "",
                                  placeholder: "Seleccione un usuario...",
                                  danger: _vm.errors.has(
                                    "ed-permissions-form.selectedUserId"
                                  ),
                                  "danger-text": _vm.errors.first(
                                    "ed-permissions-form.selectedUserId"
                                  ),
                                  "show-option-all": true
                                },
                                model: {
                                  value: _vm.selectedUserId,
                                  callback: function($$v) {
                                    _vm.selectedUserId = $$v
                                  },
                                  expression: "selectedUserId"
                                }
                              })
                            : _c(
                                "vs-select",
                                {
                                  staticClass: "w-100",
                                  attrs: {
                                    autocomplete: "",
                                    label: "",
                                    disabled: ""
                                  },
                                  model: {
                                    value: _vm.selectedUserId,
                                    callback: function($$v) {
                                      _vm.selectedUserId = $$v
                                    },
                                    expression: "selectedUserId"
                                  }
                                },
                                [
                                  _c("vs-select-item", {
                                    attrs: {
                                      value: _vm.permission.idEntidad,
                                      text: _vm.permission.nombreEntidad
                                    }
                                  })
                                ],
                                1
                              )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.referenceType === _vm.referenceTypes.GROUP
                    ? _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "(*) Grupo",
                            "label-for": "selectedGroupId"
                          }
                        },
                        [
                          _c("ListGroups", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required:
                                    _vm.referenceType ===
                                    _vm.referenceTypes.GROUP
                                },
                                expression:
                                  "{ required: referenceType === referenceTypes.GROUP }"
                              }
                            ],
                            ref: "selectedGroupId",
                            staticClass: "w-100",
                            attrs: {
                              autocomplete: "",
                              label: "",
                              id: "selectedGroupId",
                              name: "selectedGroupId",
                              typeList: _vm.stepTypes.GROUP,
                              "data-vv-as": "Grupo",
                              danger: _vm.errors.has(
                                "ed-permissions-form.selectedGroupId"
                              ),
                              "danger-text": _vm.errors.first(
                                "ed-permissions-form.selectedGroupId"
                              ),
                              disabled:
                                _vm.permission !== null && _vm.fromEditor
                            },
                            model: {
                              value: _vm.selectedGroupId,
                              callback: function($$v) {
                                _vm.selectedGroupId = $$v
                              },
                              expression: "selectedGroupId"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "b-form-group",
                    { attrs: { "data-cy": "permissions" } },
                    [
                      _c("label", [_vm._v("Permisos")]),
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: {
                            value: 1,
                            "unchecked-value": 0,
                            disabled: _vm.owner
                          },
                          model: {
                            value: _vm.read,
                            callback: function($$v) {
                              _vm.read = $$v
                            },
                            expression: "read"
                          }
                        },
                        [_vm._v(" Lectura ")]
                      ),
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: {
                            value: 1,
                            "unchecked-value": 0,
                            disabled: _vm.owner
                          },
                          model: {
                            value: _vm.write,
                            callback: function($$v) {
                              _vm.write = $$v
                            },
                            expression: "write"
                          }
                        },
                        [_vm._v(" Escritura ")]
                      ),
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: {
                            value: 1,
                            "unchecked-value": 0,
                            disabled: _vm.owner
                          },
                          model: {
                            value: _vm.totalControl,
                            callback: function($$v) {
                              _vm.totalControl = $$v
                            },
                            expression: "totalControl"
                          }
                        },
                        [_vm._v(" Control total ")]
                      )
                    ],
                    1
                  ),
                  _c("hr"),
                  _c(
                    "b-form-group",
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: { disabled: _vm.owner },
                          model: {
                            value: _vm.applyToChildren,
                            callback: function($$v) {
                              _vm.applyToChildren = $$v
                            },
                            expression: "applyToChildren"
                          }
                        },
                        [
                          _vm._v(
                            " Aplicar estos permisos a los archivos y carpetas interiores "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.owner
                ? _c("div", { staticClass: "message-owner" }, [
                    _vm._v(
                      " No es posible cambiar los permisos del propietario. "
                    )
                  ])
                : _vm._e(),
              _vm.alreadyExists && !_vm.fromEditor
                ? _c("div", { staticClass: "message-exists" }, [
                    _vm._v(
                      " Ya se habian configurado estos permisos, puedes cambiarlos si lo necesitas. "
                    )
                  ])
                : _vm._e(),
              _vm.noPermissions
                ? _c("div", { staticClass: "message-exists" }, [
                    _vm._v(
                      " Debes seleccionar al menos 1 permiso para poder guardar. Si estas editando y quieres quitar todos los permisos, debes eliminar la asignación desde el panel de permisos. "
                    )
                  ])
                : _vm._e(),
              _c("vs-divider", { staticClass: "pt-32" }),
              _c(
                "div",
                { staticClass: "d-flex justify-end" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-3",
                      class: { "cursor-not-allowed": _vm.disabledSaveBtn },
                      attrs: {
                        variant: "outline-primary",
                        disabled: _vm.disabledSaveBtn
                      },
                      on: { click: _vm.save }
                    },
                    [
                      _vm._v(" Guardar "),
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        staticClass:
                          "spinner-border spinner-border-sm text-white"
                      })
                    ]
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-3",
                      attrs: { variant: "outline-danger" },
                      on: { click: _vm.clearForm }
                    },
                    [
                      _vm._v(" Cancelar "),
                      _c("span", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        staticClass:
                          "spinner-border spinner-border-sm text-white"
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }